module.exports = __webpack_public_path__ + "img/second-0-opened.2d063c71.webp";